import plData from './pl.js';
import enData from './en.js';

var langData = {
    'pl' : plData,
    'en' : enData
};

export default langData;